"use strict";

var EventEmitter = require("events").EventEmitter;
var LoggerInstance = require("js-logger").get("TokenStore");

var Dispatcher = require("../dispatcher/Dispatcher");

// Note: when we consilidate constants, consider that ProjectConstants.INITIALIZE is double-purposed here
var ProjectConstants = require("../projectComponents/ProjectConstants");

var CHANGE_EVENT = "change";

var getByConstant = function (actionType) {
	return state.rules.filter(rule => {
		return rule.triggers.indexOf(actionType) !== -1;
	});
};

var updateToken = function (token, $elements) {
	$elements.text(token);
};

var executeRules = function (action, $context) {
	var rulesToTrigger = getByConstant(action.actionType);
	var executed = false;

	if (rulesToTrigger.length > 0) {
		rulesToTrigger.forEach(rule => {
			if (typeof rule.shouldTrigger != "function" || rule.shouldTrigger(action)) {
				var token = rule.getToken(action);
				updateToken(token, rule.elements($context || $("body")));
			}
		});
		executed = true;
	}

	return executed;
};

var state = {
	rules: [],
	isDesignMode: false
};

var TokenStore = Object.assign({}, EventEmitter.prototype, {
	getState: function () {
		return state;
	},

	get: function (key) {
		return state[key];
	},

	addRule: function (rule, $context) {
		state.rules.push(rule);

		if (typeof rule.initialize === "function") {
			var token = rule.initialize();

			updateToken(token, rule.elements($context || $("body")));
		}
	},

	removeRule: function (identifier, removeToken) {
		var index = state.rules.findIndex(rule => rule.identifier === identifier);

		if (index === -1) {
			return;
		}

		state.rules.splice(index, 1);
	},

	hasRule: function (identifier) {
		return state.rules.some(rule => rule.identifier === identifier);
	},

	handleDrop: function ($context) {
		state.rules.forEach(rule => {
			if (typeof rule.initialize === "function") {
				var token = rule.initialize();

				updateToken(token, rule.elements($context || $("body")));
			}
		});
	},

	addChangeListener: function (callback) {
		this.on(CHANGE_EVENT, callback);
	},

	removeChangeListener: function (callback) {
		this.removeListener(CHANGE_EVENT, callback);
	},

	emitChange: function () {
		this.emit(CHANGE_EVENT);
	}
});

TokenStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case ProjectConstants.INITIALIZE:
			state.isDesignMode = action.options.isDesignMode;
			return true;
	}

	if (executeRules(action)) {
		TokenStore.emitChange();
	}

	return true;
});

module.exports = TokenStore;



// WEBPACK FOOTER //
// ./Javascript/client/TokenStore.jsx